module.exports = __webpack_public_path__ + "static/media/1681434192347-Cohesive_Logo.abc853ac.png";